const getters = {
    defaultPage: state => state.account.defaultPage,
    menu: state => state.account.menu,
    customer: state => state.customer.customer,
  }
  export default getters
  


// WEBPACK FOOTER //
// ./src/store/getters.js